"use client";
import useStoreKeys from "@/hooks/useStoreKeys";
import { getTranslatedPath } from "@/i18n/urls/urls";
import clsx from "clsx";
import Link, { LinkProps } from "next/link";
import { HTMLAttributes } from "react";
import styles from "./TranslatedLink.module.scss";

type Props = LinkProps &
	HTMLAttributes<HTMLAnchorElement> & {
		language?: string;
		href: string;
		onlyHref?: boolean;
		hrefPrefix?: string;
		children?: React.ReactNode;
		underlined?: boolean;
	};

export default function TranslatedLink({
	language,
	href,
	hrefPrefix,
	children,
	onlyHref = false,
	underlined = false,
	...props
}: Props) {
	const translatedHref = getTranslatedLink({ language, href, hrefPrefix });

	if (onlyHref) return translatedHref;

	return (
		<Link
			href={translatedHref}
			{...props}
			className={clsx([styles.link, underlined ? styles.underlined : ""])}
		>
			{children}
		</Link>
	);
}

export const getTranslatedLink = ({
	language = "",
	href = "",
	hrefPrefix = "",
}) => {
	const { store, lang } = useStoreKeys();

	let prefix = "";

	if (store !== "global") {
		prefix = hrefPrefix ? hrefPrefix : `/${store}/${lang}`;
	}

	return getTranslatedPath({
		language: language ? language : lang,
		url: href,
		prefix: prefix,
	});
};
